// extracted by mini-css-extract-plugin
export default {"wrap__ErrorBoundary":"ErrorBoundary_wrap__ErrorBoundary__ohE77"};